import Kurikulum from '../../views/Kurikulum/Kurikulum.view';
import { connect } from 'react-redux';

function mapStateToProps(state) {
    return {
        user: state.user || {},
      };
  }

export default connect(mapStateToProps, null)(Kurikulum);